// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { core as baseCoreTheme } from "@stepstone-genesis/design-tokens";

// src/details.ts
var defaultComponentDetails = {
  FORM_INPUT: {
    styles: {
      responsiveVariants: [
        {
          id: "form-input-size",
          variants: {
            medium: {
              minHeight: "46px"
            }
          }
        }
      ]
    }
  },
  FORM_INPUT_GROUP: {
    props: {
      groupStyles: {
        _firstChild: {
          borderTopLeftRadius: "radiusRound",
          borderBottomLeftRadius: "radiusRound",
          borderTopRightRadius: "radiusNone",
          borderBottomRightRadius: "radiusNone",
          // if elements wrapped in additional divs
          ".form-input-container, button, select": {
            borderTopLeftRadius: "radiusRound",
            borderBottomLeftRadius: "radiusRound"
          }
        },
        ":last-child": {
          borderTopRightRadius: "radiusRound",
          borderBottomRightRadius: "radiusRound",
          // if elements wrapped in additional divs
          ".form-input-container, button, select": {
            borderTopRightRadius: "radiusRound",
            borderBottomRightRadius: "radiusRound"
          }
        }
      }
    }
  },
  BADGE: {
    styles: {
      base: {
        borderRadius: "radiusRound"
      },
      variants: {
        default: {
          boxShadow: "boxShadowNone"
        },
        positive: {
          boxShadow: "boxShadowNone"
        },
        warning: {
          boxShadow: "boxShadowNone"
        },
        negative: {
          boxShadow: "boxShadowNone"
        },
        info: {
          boxShadow: "boxShadowNone"
        }
      }
    }
  },
  BADGE_TEXT: {
    props: {
      size: "xs",
      textTransform: "none",
      fontWeight: "fontWeightNormal"
    }
  },
  CARD: {
    styles: {
      base: {
        borderRadius: "radiusXl"
      },
      responsiveVariants: [
        {
          id: "card-full-width",
          variants: {
            true: {
              borderRadius: "radiusNone",
              boxShadow: "inset 0 1px, inset 0 -1px"
            },
            false: {
              borderRadius: "radiusXl",
              boxShadow: "boxShadowBorderDefault"
            }
          }
        }
      ]
    }
  },
  CARD_HEADER_CONTAINER: {
    styles: {
      base: {
        borderRadius: "radiusXl",
        borderBottomLeftRadius: "radiusNone",
        borderBottomRightRadius: "radiusNone",
        _notExpanded: {
          borderBottomLeftRadius: "radiusXl",
          borderBottomRightRadius: "radiusXl"
        }
      }
    }
  },
  CARD_GROUP_ROOT: {
    props: {
      borderRadius: "radiusXl"
    }
  },
  DIALOG_CARD: {
    styles: {
      base: {
        borderRadius: "radiusXl"
      },
      responsiveVariants: [
        {
          id: "dialog-card-sticky",
          variants: {
            false: {
              borderBottomLeftRadius: "radiusXl",
              borderBottomRightRadius: "radiusXl"
            },
            true: {
              borderBottomLeftRadius: "radiusNone",
              borderBottomRightRadius: "radiusNone"
            }
          }
        }
      ]
    }
  },
  FORM_INPUT_CONTAINER: {
    styles: {
      base: {
        borderRadius: "radiusRound"
      }
    }
  },
  FORM_TEXTAREA_CONTAINER: {
    styles: {
      base: {
        borderRadius: "radiusXl"
      }
    }
  },
  FORM_SELECT_CONTAINER: {
    styles: {
      base: {
        '&[data-genesis-element="FORM_SELECT_CONTAINER_MULTIPLE"]': {
          borderRadius: "radiusXl"
        }
      }
    }
  },
  FORM_SELECT: {
    styles: {
      responsiveVariants: [
        {
          id: "form-select-size",
          variants: {
            medium: {
              minHeight: "size60"
            }
          }
        }
      ]
    }
  },
  TABLE_CONTAINER: {
    styles: {
      base: {
        thead: {
          "> tr:first-of-type th:first-of-type": {
            borderTopLeftRadius: "radiusXl"
          },
          "> tr:first-of-type th:last-child": {
            borderTopRightRadius: "radiusXl"
          }
        },
        "& > thead + tbody > tr:last-child td:first-of-type": {
          borderBottomLeftRadius: "radiusXl"
        },
        "& > thead + tbody > tr:last-child td:last-child": {
          borderBottomRightRadius: "radiusXl"
        },
        "& > tr:first-of-type td:first-of-type, &  > tr:first-of-type th:first-of-type": {
          borderTopLeftRadius: "radiusXl"
        },
        "& > tr:first-of-type td:last-child,& > tr:first-of-type th:last-child": {
          borderTopRightRadius: "radiusXl"
        },
        "& > tr:last-child td:first-of-type,& > tr:last-child th:first-of-type": {
          borderBottomLeftRadius: "radiusXl"
        },
        "& > tr:last-child td:last-child,& > tr:last-child th:last-child": {
          borderBottomRightRadius: "radiusXl"
        }
      }
    }
  },
  TOAST: {
    styles: {
      variants: {
        default: {
          outlineColor: "colorStatusDefault"
        },
        positive: {
          outlineColor: "colorStatusPositiveDefault"
        },
        warning: {
          outlineColor: "colorStatusWarningDefault"
        },
        negative: {
          outlineColor: "colorStatusNegativeDefault"
        },
        info: {
          outlineColor: "colorStatusInfoDefault"
        }
      }
    }
  },
  TABS: {
    styles: {
      base: {
        borderTopLeftRadius: "radiusL",
        borderTopRightRadius: "radiusL",
        _focusVisible: {
          borderTopLeftRadius: "radiusL",
          borderTopRightRadius: "radiusL"
        }
      }
    }
  }
};

// src/index.ts
var core = extendBaseTheme("core", baseCoreTheme, defaultComponentDetails);
export {
  core
};
